import styled from "styled-components";
import FarmImage from "../../../../assets/images/organic-meadow-blossoms-vibrant-summer-sunset.jpeg";

export const Wrapper = styled.div`
  min-height: 100vh;
  display: grid;
  grid-template-columns: minmax(440px, 0.92fr) minmax(520px, 1.08fr);
  background: #fff;
  color: #1b231e;
  font-family: "Halenoir", sans-serif;

  .login-panel {
    position: relative;
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    padding: 40px clamp(32px, 5vw, 76px) 28px;
  }

  .brand { width: 150px; }
  .brand img { display: block; width: 100%; }

  .form-shell {
    width: 100%;
    max-width: 440px;
    margin: auto;
    padding: 40px 0;
  }

  .mobile-mark { display: none; }

  .eyebrow {
    display: inline-block;
    margin-bottom: 14px;
    color: #0b7a3b;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
  }

  h1 {
    margin: 0 0 10px;
    color: #16251d;
    font-size: clamp(34px, 4vw, 44px);
    font-weight: 700;
    letter-spacing: -0.035em;
    line-height: 1.1;
    font-family: "Kamerik 205", sans-serif;
  }

  .intro {
    max-width: 410px;
    margin: 0 0 34px;
    color: #6b756f;
    font-size: 15px;
    line-height: 1.7;
  }

  .server-error {
    margin-bottom: 18px;
    border: 1px solid #f2c5c5;
    border-radius: 10px;
    background: #fff7f7;
    padding: 11px 13px;
    color: #a32929;
    font-size: 13px;
    line-height: 1.5;
  }

  .field-group { margin-bottom: 20px; }
  .label-row { display: flex; align-items: center; justify-content: space-between; gap: 16px; }

  label {
    display: block;
    margin-bottom: 8px;
    color: #24352c;
    font-size: 13px;
    font-weight: 600;
  }

  .label-row a, .help-text a {
    color: #087a3a;
    font-size: 12px;
    font-weight: 600;
    text-decoration: none;
  }
  .label-row a:hover, .help-text a:hover { text-decoration: underline; }

  .field {
    display: flex;
    height: 52px;
    align-items: center;
    gap: 12px;
    border: 1px solid #dce3df;
    border-radius: 12px;
    background: #fff;
    padding: 0 15px;
    transition: border-color 160ms ease, box-shadow 160ms ease;
  }
  .field:focus-within { border-color: #0b8742; box-shadow: 0 0 0 3px rgba(11, 135, 66, 0.12); }
  .field.has-error { border-color: #cf4949; }
  .field > svg { flex: 0 0 auto; color: #849189; font-size: 18px; }

  input {
    min-width: 0;
    flex: 1;
    border: 0;
    background: transparent;
    color: #1b231e;
    font-size: 14px;
    outline: 0;
  }
  input::placeholder { color: #a8b0ab; }

  .visibility-toggle {
    display: grid;
    flex: 0 0 auto;
    place-items: center;
    border: 0;
    background: none;
    padding: 4px;
    color: #78847d;
    cursor: pointer;
  }
  .visibility-toggle:hover { color: #16251d; }

  .field-error { margin: 6px 0 0; color: #bd3030; font-size: 12px; }

  .submit-button {
    display: flex;
    width: 100%;
    height: 54px;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-top: 28px;
    border: 0;
    border-radius: 12px;
    background: #087a3a;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    box-shadow: 0 10px 24px rgba(8, 122, 58, 0.18);
    cursor: pointer;
    transition: background 160ms ease, transform 160ms ease;
  }
  .submit-button:hover:not(:disabled) { background: #06652f; transform: translateY(-1px); }
  .submit-button:disabled { cursor: wait; opacity: 0.72; }

  .spinner {
    width: 17px;
    height: 17px;
    border: 2px solid rgba(255,255,255,.45);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin .7s linear infinite;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  .help-text { margin: 26px 0 0; color: #7c8780; font-size: 12px; text-align: center; }
  .copyright { margin: auto 0 0; color: #9ba49f; font-size: 11px; }

  .visual-panel {
    position: relative;
    min-height: 100vh;
    overflow: hidden;
    background-image: linear-gradient(180deg, rgba(8, 48, 27, 0.14), rgba(6, 44, 24, 0.84)), url(${FarmImage});
    background-position: center;
    background-size: cover;
  }
  .visual-panel::before {
    position: absolute;
    inset: 0;
    background-image: radial-gradient(rgba(255,255,255,.13) 1px, transparent 1px);
    background-size: 18px 18px;
    content: "";
    mask-image: linear-gradient(to bottom, transparent, black);
  }

  .visual-content {
    position: absolute;
    right: clamp(34px, 5vw, 72px);
    bottom: clamp(48px, 8vh, 92px);
    left: clamp(34px, 5vw, 72px);
    max-width: 560px;
    color: #fff;
  }
  .logo-mark {
    display: grid;
    width: 54px;
    height: 54px;
    place-items: center;
    margin-bottom: 28px;
    border: 1px solid rgba(255,255,255,.28);
    border-radius: 16px;
    background: rgba(255,255,255,.13);
    backdrop-filter: blur(10px);
  }
  .logo-mark img { width: 35px; height: 35px; object-fit: contain; }
  .quote { margin: 0 0 18px; font-family: "Kamerik 205", sans-serif; font-size: clamp(34px, 4vw, 54px); font-weight: 600; letter-spacing: -.035em; line-height: 1.12; }
  .visual-content > span { color: rgba(255,255,255,.72); font-size: 13px; letter-spacing: .08em; text-transform: uppercase; }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    .visual-panel { display: none; }
    .login-panel { padding: 30px 24px 24px; }
    .form-shell { max-width: 460px; }
  }

  @media (max-width: 520px) {
    .login-panel { padding: 24px 20px; }
    .brand { width: 130px; }
    .form-shell { padding: 54px 0 38px; }
    h1 { font-size: 34px; }
    .intro { margin-bottom: 28px; }
    .copyright { text-align: center; }
  }
`;
